import {
  Box,
  Dialog,
  IconButton,
  Paper,
  Popover,
  Slide,
  SwipeableDrawer,
  Tooltip,
  useTheme,
} from "@mui/material";
import { Task, TaskProduct } from "../../services/swagger";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { TaskService } from "../../services/api";
import ItemList from "./ItemList";
import useRefresh from "../../hooks/useRefresh";
import useBreakpoint from "../../hooks/useBreakpoint";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

interface ProductSerialSelectorProps {
  task: Task;
  taskProduct: TaskProduct;
}

interface ProductSerialSelectorContentProps
  extends ProductSerialSelectorProps {}

function ProductSerialSelectorContent(
  props: ProductSerialSelectorContentProps
) {
  const { t } = useTranslation("Product");
  const [allSerials, setAllSerials] = useState<string[]>([]);
  const refresh = useRefresh();

  useEffect(() => {
    // loadSerials();
  }, []);

  const handleChangeSerials = async (list: string[]) => {
    if (!props.task._id) return;
    const res = await TaskService.updateTaskProductSerials({
      id: props.task._id,
      updateTaskProductSerialsBody: {
        itemCode: props.taskProduct.itemCode,
        serials: list,
      },
    });
    if (res?.data?.success) refresh();
  };
  const label = `${t("Serials")} | ${props.taskProduct.itemCode} - ${
    props.taskProduct.name
  }`;
  return (
    <Box minWidth={300} p={2} maxHeight={400}>
      <ItemList
        label={label.substring(0, 37) + (label.length > 37 ? "..." : "")}
        unique
        items={props.taskProduct.serialList}
        onChange={handleChangeSerials}
        addList={
          allSerials.length > 0
            ? allSerials.map((serial) => ({
                name: serial,
                value: serial,
              }))
            : undefined
        }
        emptyLabel={t("NoSerialsAdded")}
        confirmDeletion
      />
    </Box>
  );
}

export default function ProductSerialSelector(
  props: ProductSerialSelectorProps
) {
  const { t } = useTranslation("Product");

  const [anchorEl, setAnchorEl] = useState<any>(null);

  const breakpoint = useBreakpoint();
  const theme = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!anchorEl) setAnchorEl(event.currentTarget);
    else setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Tooltip title={t("Serials")} placement="top" arrow>
        <IconButton onClick={handleClick}>
          <FormatListBulletedIcon />
        </IconButton>
      </Tooltip>
      {breakpoint.md ? (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
        >
          <ProductSerialSelectorContent {...props} />
        </Popover>
      ) : (
        <SwipeableDrawer
          anchor="bottom"
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onOpen={() => {}}
          sx={{ zIndex: 1300 }}
          PaperProps={{
            sx: {
              maxHeight: "70%",
              borderTopRightRadius: 2 * (theme.shape.borderRadius as number),
              borderTopLeftRadius: 2 * (theme.shape.borderRadius as number),
              p: 2,
              pb: 4,
            },
          }}
        >
          <ProductSerialSelectorContent {...props} />
        </SwipeableDrawer>
      )}
    </Box>
  );
}
